// Copyright (c) 2016 Deere & Company

import ClaimSearchContainer from '../../claim/claim-search/state-connector';
export default {
    component: ClaimSearchContainer,
    name: 'CLAIM_SEARCH',
    path: 'search'
};



// WEBPACK FOOTER //
// ./src/routes/claims/claim-search.js